import { BsLinkedin, BsGithub } from "react-icons/bs";
import { FaGooglePlay } from "react-icons/fa";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div className="footer">
      <div className="social">
        <a href="https://www.linkedin.com/in/mirchm/">
          <BsLinkedin size={35} />
        </a>
        <a href="https://github.com/MirchM">
          <BsGithub size={35} />
        </a>
        <a href="https://play.google.com/store/apps/developer?id=MMISoft">
          <FaGooglePlay size={35} />
        </a>
      </div>
      <div className="right-section">
        <Link to="/Contact">Contact</Link>
      </div>
    </div>
  );
};

export default Footer;
